import URL from '../helper';
import axiosCall from './interceptor';

export const addNewUser = async data => {
  const url = `${URL.BASE_URL}user`;
  let response = await axiosCall('post', url, data, false);
  return response.data;
};

export const getUserRole = async data => {
  const url = `${URL.BASE_URL}user/role`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getUser = async userType => {
  const url = `${URL.BASE_URL}user?userType=${userType}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const deleteUser = async payload => {
  const url = `${URL.BASE_URL}user?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const updateUser = async data => {
  const url = `${URL.BASE_URL}user`;
  let response = await axiosCall('put', url, data, false);
  return response.data;
};

export const reInviteUser = async id => {
  const url = `${URL.BASE_URL}reInviteUser?id=${id}`;
  let response = await axiosCall('post', url);
  return response.data;
};

export const getThresholdAlert = async () => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}thresholdAlert`;
  const response = await axiosCall('get', url);
  return response.data;
}

export const patchThresholdAlert = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}thresholdAlert`;
  const response = await axiosCall('post', url, payload);
  return response.data;
}